import React, { useState } from 'react'
import { Modal, TableCell } from '@mui/material'
import moment from 'moment'

export function DuplicateImagesTableItems({ item }) {
    const [open, setOpen] = useState(false)
    const [activeImage, setActiveImage] = useState(null)

    const handleOpenModal = (src) => {
        setActiveImage(src)
        setOpen(true)
    }

    const handleCloseModal = () => {
        setOpen(false)
        setActiveImage(null)
    }
    return (
        <>
            <Modal open={open} onClose={handleCloseModal}>
                <div
                    className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black/80 z-50"
                    onClick={handleCloseModal} // Clicking outside will trigger this
                >
                    <div
                        className="max-w-[90%] max-h-[90%] rounded-[12px] shadow-lg"
                        onClick={(e) => e.stopPropagation()} // Prevent clicks inside from closing
                    >
                        <img src={activeImage} alt="Preview" className="w-full h-full object-contain" />
                    </div>
                </div>
            </Modal>

            <TableCell>
                <div
                    className="w-[60px] h-[60px] border overflow-hidden rounded-[10px] cursor-pointer"
                    onClick={() => handleOpenModal(item?.mainPhoto)}
                >
                    <img src={item?.mainPhoto} className="w-full h-full object-cover" alt="MainPhoto" />
                </div>
            </TableCell>
            <TableCell>
                <div
                    className="w-[60px] h-[60px] border overflow-hidden rounded-[10px] cursor-pointer"
                    onClick={() => handleOpenModal(item?.snapshotUrl)}
                >
                    <img src={item?.snapshotUrl} className="w-full h-full object-cover" alt="MainPhoto" />
                </div>
            </TableCell>
            <TableCell className="flex items-center justify-center text-center">
                {item?.firstName}
                {' '}
                {item?.lastName}
                {' '}
                {item?.patronymicName}
            </TableCell>
            <TableCell>
                {moment(item?.attendanceDatetime).format('YYYY-MM-DD, HH:mm:a')}
            </TableCell>
            <TableCell>
                {moment(item?.createdAt).format('YYYY-MM-DD, HH:mm:a')}
            </TableCell>
            <TableCell>
                {item?.appVersionCode}
            </TableCell>
            <TableCell>
                {item?.deviceId}
            </TableCell>
            <TableCell>
                {item?.deviceName}
            </TableCell>
            <TableCell>
                {item?.distanceLocation}
            </TableCell>
            <TableCell>
                {item?.externalId}
            </TableCell>
            <TableCell>
                {item?.imageSizeType}
            </TableCell>
        </>
    )
}
